import { BrowserRouter as Router, Routes, Route, useLocation, useParams } from 'react-router-dom';
import { useEffect } from 'react';
import { API_BASE } from './components/config';

import Login from './components/Login';
import Dashboard from './components/Dashboard';
import Checkin from './components/Checkin';
import Register from './components/Register';
import AutoMatch from './components/AutoMatch';
import PlayerManager from './components/PlayerManager';
import Monitor from "./components/Monitor";
import PlayerHistory from './components/PlayerHistory';
import LineAuth from './components/LineAuth';
import RankTable from './components/RankTable';
import JoinCheckin from './components/JoinCheckin';
import QrCheckinLogin from './components/QrCheckinLogin';
import GroupMatchAdmin from './components/GroupMatchAdmin';
import SystemAdmin from './components/SystemAdmin';
import Reward from './components/Reward';
import AdminRewards from './components/AdminRewards';
import MatchPlanner from './components/MatchPlanner';
import MatchRequest from './components/MatchRequest';
import AdminResultLog from './components/AdminResultLog';
import AdminMatchAnalytics from './components/AdminMatchAnalytics';
import AdminDatabaseBackup from './components/AdminDatabaseBackup';
import AdminQrPage from './components/AdminQrPage';
import AdminSidebar from './components/AdminSidebar';
import GameMatchControlPage from './components/GameMatchControlPage';
import AdminCheckinPage from './components/AdminCheckinPage';
import LineBrowserGuard from './components/LineBrowserGuard';
import InstallShortcut from './components/InstallShortcut';
import AdminPlayerEditModal from './components/AdminPlayerEditModal';
import SystemMonitor from './components/SystemMonitor';
import AdminLineLink from './components/AdminLineLink';
import PickOneAutoTest from './components/PickOneAutoTest';
import './css/tokens.css';
import './css/layout.css';
import './css/ResponsiveFixes.css';
import './css/admin-alerts.css';
import './css/typography.css';

/* ================= AUTO MATCH ================= */

function AutoMatchWrapper() {
  const { groupId } = useParams();
  return <main className="admin-shell-with-sidebar"><AdminSidebar active="planner" groupId={Number(groupId)} /><AutoMatch groupId={Number(groupId)} /></main>;
}

/* ================= PLAYER MANAGER ================= */

function PlayerManagerWrapper() {
  const { groupId } = useParams();
  return <main className="admin-shell-with-sidebar"><AdminSidebar active="users" groupId={Number(groupId)} /><PlayerManager groupId={Number(groupId)} /></main>;
}

function SiteVisitTracker() {
  const location = useLocation();
  useEffect(() => {
    let visitorKey = localStorage.getItem('siteVisitorKey');
    if (!visitorKey) {
      visitorKey = `${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 14)}`;
      localStorage.setItem('siteVisitorKey', visitorKey);
    }
    let user = null;
    try { user = JSON.parse(localStorage.getItem('user') || 'null'); } catch {}
    fetch(`${API_BASE}/api/site/visit`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ visitor_key: visitorKey, user_id: user?.user_id || null, path: location.pathname })
    }).catch(() => {});
  }, [location.pathname]);
  return null;
}

/* ================= APP ================= */

function App() {
  return (
    <Router>
      <SiteVisitTracker />
      <LineBrowserGuard />
      <InstallShortcut />
      <AdminPlayerEditModal />
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/profile" element={<PlayerHistory profileMode />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/checkin" element={<Checkin />} />
        <Route path="/join/:groupId" element={<JoinCheckin />} />
        <Route path="/join/:groupId/login" element={<QrCheckinLogin />} />
        <Route path="/Register" element={<Register />} />
        <Route path="/monitor" element={<Monitor />} />
        <Route path="/monitor/:groupId" element={<Monitor />} />
        <Route path="/player-history/:groupId/:userId" element={<PlayerHistory />} />
        <Route path="/line-auth" element={<LineAuth />} />
        <Route path="/gameauto/:groupId" element={<AutoMatchWrapper />} />
        <Route path="/players/:groupId" element={<PlayerManagerWrapper />} />
        <Route path="/admin_monitor" element={<SystemMonitor />} />
        <Route path="/admin_monitor/:groupId" element={<SystemMonitor />} />
        <Route path="/admin/group/:groupId/matches" element={<GroupMatchAdmin />} />
        <Route path="/admin/users" element={<SystemAdmin />} />
        <Route path="/admin/line-links" element={<AdminLineLink />} />
        <Route path="/admin/pick-one-auto-test" element={<PickOneAutoTest />} />
        <Route path="/rewards" element={<Reward />} />
        <Route path="/admin/rewards" element={<AdminRewards />} />
        <Route path="/admin/result-logs" element={<AdminResultLog />} />
        <Route path="/admin/match-analytics" element={<AdminMatchAnalytics />} />
        <Route path="/admin/database-backup" element={<AdminDatabaseBackup />} />
        <Route path="/admin/checkin-qr" element={<AdminQrPage mode="checkin" />} />
        <Route path="/admin/monitor-qr" element={<AdminQrPage mode="monitor" />} />
        <Route path="/admin/checkin/:groupId" element={<AdminCheckinPage />} />
        <Route path="/match-planner/:groupId" element={<MatchPlanner />} />
        <Route path="/game-match-control/:groupId" element={<GameMatchControlPage />} />
        <Route path="/match-request" element={<MatchRequest />} />
<Route
  path="/rank"
  element={<RankTable />}
/>
      </Routes>
    </Router>
  );
}

export default App;
